// extracted by mini-css-extract-plugin
export default {"highlight":"src-components-HighlightText-index-module_highlight--Jory7"};